import ExerciseTagsTable from './ExerciseTagsTable';

export default ExerciseTagsTable;
